import { SearchResult } from '@app/models/search-result';
import { Site } from '@microsoft/microsoft-graph-types';
import { Observable } from 'rxjs';

export class NewsPage {
  public Title: string;
  public Description: string;
  public Path: string;
  public Picture: string;
  public PublishedDate: Date;
  public ViewsCount: number;
  public CommentsCount: number;
  public LikesCount: number;
  public GUID: string;
  public Channels: Array<any>;
  public LanguageTermId?: string;
  public ShowNewOrModifiedBadge: boolean;
  public SiteName: string;
  public SiteUrl: string;
  public SiteInfo$?: Observable<Site>;
  public PageInfo$?: Observable<NewsPage>;
  public IsSharePointNews?: boolean;
  public hide?: boolean;
  public SenderTags?: Array<any>;

  constructor(opt?: Partial<NewsPage>) {
    Object.assign(this, opt);
  }

  static fromSearchResult(result: SearchResult, newsAmountOfCommentsMP, newsAmountOfLikesMP, newsChannelMP, pageLanguageMP, newsSenderTagMP?): NewsPage {

    return new this({
      Title: result ? result.Title : null,
      Description: result ? result.Description : null,
      Path: result ? result.Path : null,
      Picture: result && result.PictureThumbnailURL ? result.PictureThumbnailURL : null,
      PublishedDate: result ? result.FirstPublishedDate : null,
      ViewsCount: result ? result.ViewsLifeTimeUniqueUsers : 0,
      CommentsCount: result && result[newsAmountOfCommentsMP] ? result[newsAmountOfCommentsMP] : 0,
      LikesCount: result && result[newsAmountOfLikesMP] ? result[newsAmountOfLikesMP] : 0,
      Channels: result && result[newsChannelMP] ? this.parseManagedMetaDataString(result[newsChannelMP]) : null,
      LanguageTermId: result && result[pageLanguageMP] ? this.getManagedMetaDataTermId(result[pageLanguageMP])[0] : '',
      SiteUrl: result && result.SPWebUrl ? result.SPWebUrl : null,
      IsSharePointNews: true,
      SenderTags: result && result[newsSenderTagMP] ? this.parseManagedMetaDataString(result[newsSenderTagMP]) : null
    });
  }

  static fromSPHomeResult(result: any): NewsPage {
    return new this({
      Title: result ? result.Title : null,
      Description: result ? result.Description : null,
      Path: result ? result.Url : null,
      Picture: result ? result.ImageUrl : null,
      PublishedDate: result ? result.FirstPublishedDate : null,
      SiteName: result ? result.Site.Title : null,
      SiteUrl: result ? result.Site.Url : null,
      IsSharePointNews: true
    });
  }

  static parseManagedMetaDataString(channels: string): string[] {
    // EXAMPLE:
    // "GP0|#fa47a309-9bf1-41c5-ae0e-c96fec918fb0;"
    // "L0|#0fa47a309-9bf1-41c5-ae0e-c96fec918fb0|Lund;"
    // "GTSet|#d1a62611-0513-4d6a-92e2-9b250a08c5c3;
    // "GPP|#bf474651-16af-430b-a1c7-3be0003f0f98;"
    // "GPP|#cd878a30-546c-4275-9e88-08114d03c079;"
    // "GPP|#48dfae2a-0b81-46dd-872f-d60b08a7c702;"
    // "GP0|#5ae92d29-5d4a-440e-b0a2-2e8bf0468ba0;"
    // "L0|#05ae92d29-5d4a-440e-b0a2-2e8bf0468ba0|Chef;"
    // "GPP|#601ef509-add9-4237-a80f-039f87615b6b;"
    // "GPP|#79a51917-cf59-4470-81c4-a74e12be48cc"
    return channels.split(';').filter(c => c.split('|').length === 3).map(c => c.split('|')[2]);
  }

  static getManagedMetaDataTermId(metadatastring: string): string[] {
    // The language used always have 3 parts split by | and the guid starts with '#0' so slice away those two
    // EXAMPLE:
    // "GP0|#8718ab35-a7d9-4d99-9945-1f5cc5742224;"
    // "L0|#08718ab35-a7d9-4d99-9945-1f5cc5742224|English;"
    // "GTSet|#d1a62611-0513-4d6a-92e2-9b250a08c5c3;"
    return metadatastring.split(';').filter(c => c.split('|').length === 3).map(c => c.split('|')[1].slice(2));
  }
}
